import React from 'react';

export default function LocationPicker({ city, localities, onChange }) {
    // In a real app this would be an autocomplete. 
    // For now we map to the existing text inputs but style them nicely.

    return (
        <div className="req-grid" style={{ gap: '12px' }}>
            <div className="req-field">
                <label className="req-label">City</label>
                <input
                    className="req-input"
                    value={city || ''}
                    onChange={(e) => onChange('city', e.target.value)}
                    placeholder="e.g. Mumbai"
                />
            </div>
            <div className="req-field">
                <label className="req-label">Localities / Areas</label>
                <input
                    className="req-input"
                    value={localities || ''}
                    onChange={(e) => onChange('localities', e.target.value)}
                    placeholder="Search localities..."
                />
                <div style={{ fontSize: '11px', color: 'var(--req-text-dim)' }}>
                    Separate multiple areas with commas
                </div>
            </div>
        </div>
    );
}
